import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';
import usePaginator from '../../../theme/Component/usePaginator';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { _Company, _single } from '../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const EditorCompany = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_Company)
    const paginador = usePaginator();

    const [id, setID] = useState(null);
    const [text, setText] = useState<string>("")

    const modal = useModal("Catalogo de Compañias", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        if (render) {
            setText(render)
        }
    }, [render])

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);

        
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDCompany == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
                if (selectedItem.DataBeanProperties.IDCompany) {
                    setText(selectedItem.DataBeanProperties.Name)
                }
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    const getLista = () => {
        instance.getCompanyCatalog(null).then(
            (resp: any) => {
                setLista(resp)
            }
        ).catch(err => { toast.error(err) })
    }

    const head = [
        { title: "ID ", property: "IDCompany" },
        { title: "Código País", property: "CountryCode" },
        { title: "País", property: "CountryName" },
        { title: "Nombre de la Compañía", property: "Name" },
        { title: 'Tipo Moneda', property: 'CurrencyName', visible: true },
        { title: "Descripción", property: "Description" },
        { title: "Tercero de la Empresa", property: "IDAccount" },
        { title: "Código de la Compañía", property: "Code" },
        { title: "Tercero Representante Legal", property: "IDAccountRepresentative" },
        { title: 'Archivo de Logo', property: 'LogoImageMedia', visible: true },
        { title: "Cargar archivo Plantilla", property: "DocTemplateMedia" },
        { title: "Imágen Header Reportes", property: "HeaderImageMedia" },
        { title: "Imágen Footer Reportes", property: "FooterImageMedia" },
        { title: "Título Reportes", property: "HeaderReportName" },
        { title: "Fuente de Reportes", property: "FontMedia" },
        { title: "Json Header", property: "HeaderImageJsonProperties" },
        { title: "Json Footer", property: "FooterImageJsonProperties" },
        { title: "Json Configurar Reportes", property: "DocTemplateJsonProperties" },
        { title: "Fecha de Creación", property: "Since" },

    ];

    return (
        <>
            <label>{label ?? "Compañia"}</label>
            <span className='form-control cursor ifmodal' onClick={() => modal.open()}>{text.trim() ? text : "Seleccione Compañia"}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-12">
                        <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDCompany); modal.close(); }} />
                    </div>
                </div>

            </Modal>
        </>
    )
}